<script>
    import {flagTypes} from '../../../constants.js';
    import {sgettext} from '../../../i18n.js';

    export let row = null;
</script>

{#if row && row.linked_issues.length && row.linked_issues[0].type === flagTypes.additionalWorkRequired}
    {#if row.element_instance}
        {sgettext('$$SUB_NOTIFICATION$$')}
    {:else}
        {sgettext('$$NOTIFICATION$$')}
    {/if}
{/if}